import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {
  AddressRequest,
  AddressResponse,
  MembershipResponse,
  SubscriptionDetailResponse,
  UserDetailResponseActivityLevelEnum,
  UserDetailResponseDietGoalEnum,
  UserDetailResponseDietTypeEnum,
  UserResponse,
  UserResponseGenderEnum,
} from "../openapi/client";

export interface IUser {
  id?: string;
  phoneNumber?: string;
  deliveryPhoneNumber?: string;
  fullName?: string;
  gender?: UserResponseGenderEnum | null;
  birthDate?: string | null;
  height?: number | null;
  weight?: number | null;
  targetWeight?: number | null;
  allergens?: Array<string>;
  medicalConditions?: Array<string>;
  dislikes?: Array<string>;
  address?: AddressRequest;
  roles?: Set<string>;
  activeSubscription?: SubscriptionDetailResponse;
  deliveryNote?: string;
  dietGoal?: UserDetailResponseDietGoalEnum | null;
  activityLevel?: UserDetailResponseActivityLevelEnum | null;
  dietType?: UserDetailResponseDietTypeEnum | null;
  membership?: MembershipResponse;
  mainUser?: boolean;
}

const initialState: IUser = {};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<any>) => {
      return {
        ...action.payload,
      };
    },
    resetUser: (state) => {
      return {};
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUser, resetUser } = userSlice.actions;

export default userSlice.reducer;
